Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _airbnbPropTypes = require('airbnb-prop-types');

var _withStyles = require('../themes/withStyles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var propTypes = (0, _airbnbPropTypes.forbidExtraProps)(Object.assign({}, _withStyles.withStylesPropTypes, {
  block: _propTypes2['default'].bool,
  height: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
  width: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string])
}));

var defaultProps = {
  block: false,
  height: '1ex',
  width: '60%'
};

function Shimmer(_ref) {
  var block = _ref.block,
      css = _ref.css,
      height = _ref.height,
      styles = _ref.styles,
      width = _ref.width;

  return _react2['default'].createElement('span', _extends({
    'aria-busy': 'true'
  }, css(styles.shimmer, { width: width, height: height }, block && styles.block)));
}

Shimmer.componentCategory = 'Core';
Shimmer.displayName = 'Shimmer';
Shimmer.propTypes = propTypes;
Shimmer.defaultProps = defaultProps;

exports['default'] = (0, _withStyles.withStyles)(function () {
  return {
    block: {
      display: 'block'
    },

    shimmer: {
      animationDirection: 'alternate',
      animationDuration: '1s',
      animationFillMode: 'forwards',
      animationIterationCount: 'infinite',
      animationName: {
        from: { opacity: 0.1 },
        to: { opacity: 0.3 }
      },
      animationTimingFunction: 'ease-in-out',
      backgroundColor: 'currentColor',
      display: 'inline-block',
      position: 'relative'
    }
  };
}, { pureComponent: true })(Shimmer);


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/exp/Shimmer.js
// module id = 88
// module chunks = 168707334958949